import { useToast } from 'vue-toastification'
import enums from '@/utils/enum'
import BaseHtml from '@/components/BaseHtml.vue'

function noteficationFromType(type) {
  const t = enums.notification.types
  switch (type) {
    case t.MESSAGE:
      return 'info'
    case t.ERROR:
      return 'error'
    case t.INFO:
      return 'info'
    case t.NETWORK:
      return 'success'
    case t.DANGER:
      return 'warning'
    default:
      return 'default'
  }
}

export default class Notification {
  /**
   * Create a notification instance.
   *
   * @constructor
   * @param {Object} [options={}] Constructor options.
   * @param {string} [options.msg=''] Message - can contain html.
   * @param {*} [options.type=enums.notification.types.MESSAGE] Notification type (from `enums.notification.types`).
   * @param {*} [options.severity=enums.notification.severity.INFO] Notification severity (from `enums.notification.severity`).
   * @param {Object} [options.config={}] Additional configuration options for the notification.
   * @param {null|object} [options.content=null] overwrite notification content (e.g., component, vnode, HTML, data).
   *
   * @example
   * new Notification({
   *   msg: 'A big party is happening',
   *   type: enums.notification.types.MESSAGE,
   *   severity: enums.notification.severity.SUCCESS,
   *   config: { timeout: 3000 },
   * })
   */
  constructor({
    msg = '',
    type = enums.notification.types.MESSAGE,
    severity = enums.notification.severity.INFO,
    config = {},
    content = null,
  } = {}) {
    this.msg = $t(msg)
    this.type = type
    this.severity = severity
    this.config = config
    this.content = content
  }

  dispatch() {
    const toast = useToast()
    const note = this
    // https://maronato.github.io/vue-toastification/?ref=madewithvuejs.com
    const opts = {
      type: noteficationFromType(note.type),
      position: 'top-right',
      timeout: 4000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: true, // Has to be false to remove it
      closeButton: 'button',
      icon: true,
      rtl: false,
      ...this.config,
    }
    const content = {
      component: BaseHtml,
      props: {
        html: note.msg,
      },
    }
    if (this.content) {
      toast(this.content, opts)
    } else {
      toast(content, opts)
    }
  }
}
